<div fxFlex="1 1 100%">
  <span fxFlex="1 1 100%" class="blotter_amt_align">{{orderAmt}}</span>
  <div
    fxFlex="0 0 15px"
    class="order__details__body__infobox--usd"
    [appendTo]="desktop ? 'target' : 'body'"
    bfxTooltip="{{tooltip}}"
    tooltipPosition="left"
    [title]="desktop? tooltip:''"
    *ngIf="showEquiv"
  >
    $
  </div>
</div>
